module.exports = __webpack_public_path__ + "static/media/board-911636_640.7486d759.jpg";